import {Fragment, ReactNode} from 'react';
import {cn} from '@/lib/utils';
import {Icon, IconProp} from '../Icon';
import styles from './DefinitionList.module.css';
export interface DefinitionListProps {
  className?: string;
  descriptionClassName?: string;
  descriptionTemplate?: (item: DefinitionListItem) => ReactNode;
  items: DefinitionListItem[];
  termClassName?: string;
  termTemplate?: (item: DefinitionListItem) => ReactNode;
}
export interface DefinitionListItem {
  description?: ReactNode;
  icon?: IconProp;
  term?: ReactNode;
}
export const DefinitionList = ({
  className,
  descriptionClassName,
  descriptionTemplate,
  items,
  termClassName,
  termTemplate,
}: DefinitionListProps) => {
  return (
    <dl className={cn(styles.definitionList, className)}>
      {items.map((item, index) => (
        <Fragment key={index}>
          <dt className={termClassName}>
            {item.icon != null && <Icon className="mr-2" icon={item.icon} />}
            {termTemplate == null ? item.term : termTemplate(item)}
          </dt>
          <dd className={descriptionClassName}>
            {descriptionTemplate == null ? item.description : descriptionTemplate(item)}
          </dd>
        </Fragment>
      ))}
    </dl>
  );
};
